// extracted by mini-css-extract-plugin
module.exports = {"footerTxt":"Footer_footerTxt__45RD2","footerSnsList":"Footer_footerSnsList__nBGcS","footerLinkArea":"Footer_footerLinkArea__fuY1a"};